/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Flex, Link, Skeleton, combine, noOfLines } from './Components';
import { useState } from 'react';
import { useAnnouncementContext } from './utils/AnnouncementContext';
import { parseAnnouncementBody, } from './utils/parseAnnouncementBody';
import { useReadState } from './utils/useReadState';
export const AnnouncementList = ({ announcements, ...props }) => {
    return (jsx("div", { ...props, className: combine('t-announcement_list', props.className) },
        !announcements && (jsx(Skeleton, { css: {
                margin: '10px 20px',
            } })),
        announcements && !announcements.length && (jsx(Flex, { className: "t-announcement_empty-container", css: {
                height: '500px',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            jsx("div", { className: "t-announcement_empty-text", css: {
                    textAlign: 'center',
                    color: '#505050',
                } }, "No Announcements"))), announcements === null || announcements === void 0 ? void 0 :
        announcements.map((message, i) => {
            return jsx(AnnouncementItem, { key: i, message: message });
        })));
};
export const MarkAllAsReadButton = ({ announcements, ...props }) => {
    const t = useAnnouncementContext().t;
    const [, setReadState] = useReadState();
    return (jsx(Link, { ...props, className: combine('t-announcement_mark-all', props.className), onClick: (e) => {
            var _a;
            if (announcements === null || announcements === void 0 ? void 0 : announcements.length) {
                setReadState(announcements.map((item) => item.message_id), true);
            }
            return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } }, t('Mark all as read')));
};
export const AnnouncementItem = ({ message, defaultAvatar, title, subtitle, ...props }) => {
    const defaultConfig = useAnnouncementContext();
    const t = defaultConfig.t;
    const announcementDateFormatter = defaultConfig.announcementDateFormatter;
    defaultAvatar = defaultAvatar !== null && defaultAvatar !== void 0 ? defaultAvatar : defaultConfig.defaultAvatar;
    title = title !== null && title !== void 0 ? title : defaultConfig.title;
    subtitle = subtitle !== null && subtitle !== void 0 ? subtitle : defaultConfig.subtitle;
    const [isExpanded, setExpanded] = useState(false);
    const [readState, setReadState] = useReadState();
    const isRead = readState[message.message_id];
    return (jsx(Flex, { css: {
            gap: '8px',
            padding: '12px 16px',
            cursor: 'pointer',
            backgroundColor: isRead ? undefined : 'rgba(180, 193, 213, 0.75)',
            fontSize: '16px',
            lineHeight: '24px',
        }, ...props, className: combine('t-announcement_item-container', isRead ? 't-announcement_item-container--read' : undefined, isExpanded ? 't-announcement_item-container--expanded' : undefined, props.className), onClick: (e) => {
            var _a;
            setExpanded(!isExpanded);
            setReadState(message.message_id, true);
            return (_a = props === null || props === void 0 ? void 0 : props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        } },
        jsx("div", { className: "t-announcement_item-avatar-container", css: {
                flexShrink: '0',
            } }, message.image ? (jsx("div", { className: "t-announcement_item-avatar", css: {
                overflow: 'hidden',
                width: '24px',
                height: '24px',
                borderRadius: '9999px',
            } },
            jsx("img", { src: message.image, alt: "announcement avatar", css: {
                    width: '24px',
                    height: '24px',
                    objectFit: 'contain',
                } }))) : (defaultAvatar)),
        jsx("div", { className: "t-announcement_item-body", css: {
                flex: '1',
                overflow: 'hidden',
            } },
            jsx(Flex, { className: "t-announcement_item-title-container" },
                jsx("div", { className: "t-announcement_item-title", css: {
                        flex: '1',
                        fontWeight: 'bold',
                    } }, title),
                jsx("div", { className: "t-announcement_item-date", css: {
                        flexShrink: '0',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        lineHeight: '14px',
                        color: '#505050',
                    } }, announcementDateFormatter(message.date))),
            subtitle && (jsx("div", { className: "t-announcement_item-subtitle", css: {
                    fontSize: '14px',
                    fontWeight: 'bold',
                    lineHeight: '17px',
                    color: '#6F609D',
                } }, subtitle)),
            jsx("div", { className: "t-announcement_item-message", css: [
                    isExpanded ? undefined : noOfLines,
                    {
                        '--chakra-line-clamp': 2,
                        fontSize: '14px',
                        fontWeight: 'normal',
                        lineHeight: '21px',
                    },
                ] },
                isExpanded && message.image && (jsx("img", { src: message.image, width: "100%", css: {
                        width: '100%',
                        marginBottom: '10px',
                    }, alt: "announcement photo" })),
                parseAnnouncementBody(message, {
                    raw: !isExpanded,
                })),
            jsx(Link, { className: "t-announcement_item-learn-more", hidden: isExpanded, css: {
                    marginTop: '4px',
                    color: '#C42F74',
                    fontWeight: '800',
                    fontSize: '14px',
                } }, t('Learn more')))));
};
